var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"my-3"},[_c('v-card-text',[_c('div',{staticClass:"d-flex flex-row align-center justify-space-between"},[_c('div',{staticClass:"caption sl-secondary-text"},[_vm._v("Payout Account")])]),_c('v-divider',{staticClass:"my-2"}),_c('Details',{attrs:{"stripeAccount":_vm.account}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }